import { render, staticRenderFns } from "./CoursewareIframeBlock.vue?vue&type=template&id=f7525dd0&scoped=true&"
import script from "./CoursewareIframeBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareIframeBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareIframeBlock.vue?vue&type=style&index=0&id=f7525dd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7525dd0",
  null
  
)

export default component.exports